// Pestañas del admin (reorden 24-oct-2026): Pagos (Pagos · Ajustes de cobro) y Correos (Motor · Solicitudes).
// Las rutas viejas (/admin/payment-methods, /admin/email-requests) redirigen a la pestaña, ver routes.tsx.
import type { PestanaModulo } from '../../components/common/PestanasModulo';

export const PAGOS_TABS: PestanaModulo[] = [
  { id: 'pagos', label: 'Pagos' },
  { id: 'ajustes', label: 'Ajustes de cobro' },
];
export const PAGOS_TAB_IDS = PAGOS_TABS.map((t) => t.id);

export const CORREOS_TABS: PestanaModulo[] = [
  { id: 'motor', label: 'Correos por situación' },
  { id: 'solicitudes', label: 'Solicitudes de campaña' },
];
export const CORREOS_TAB_IDS = CORREOS_TABS.map((t) => t.id);
